import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

// const config = {
//   headers: {
//     Authorization: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
//     "Content-Type": "application/json",
//     staffId: 20,
//   },
// };

const baseUrl = process.env.REACT_APP_BASE_URI;

const user = JSON.parse(localStorage.getItem("user_data")) || {};

const accountType = user?.account_type;

const initialState = {
  taxLoading: false,
  taxSuccess: false,
  taxError: false,
  taxMessage: null,
  taxData: null,

  taxClaimLoading: false,
  taxClaimSuccess: false,
  taxClaimError: false,
  taxClaimMessage: null,
  taxClaimData: null,
};

export const taxSaveData = createAsyncThunk(
  "taxSaveData",
  async (body) => {
    const { path, data } = body;
    const url = baseUrl + path;

    const result = {
      data: {
        status: 200,
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
        .post(url, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return error;
          }
        });
  }
);

export const getTaxClaimFormData = createAsyncThunk(
  "getTaxClaimFormData",
  async (body) => {
    const { path, data } = body;
    const url = baseUrl + path;

    const result = {
      data: {
        status: 200,
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
        .post(url, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          } else {
            return error;
          }
        });
  }
);


const TaxSlice = createSlice({
  name: "tax",
  initialState,

  reducers: {
    initTaxState: (state) => {
      state.taxLoading = false;
      state.taxSuccess = false;
      state.taxError = false;
      state.taxMessage = null;
      state.taxData = null;
    },
    initTaxClaim: (state) => {
      state.taxLoading = false;
      state.taxSuccess = false;
      state.taxError = false;
      state.taxMessage = null;
      state.taxData = null;
    }
  },

  extraReducers: (builder) => {
    // -------------------------------------------------
    builder.addCase(taxSaveData.pending, (state) => {
      state.taxLoading = true;
      state.taxSuccess = false;
      state.taxError = false;
      state.taxMessage = null;
      state.taxData = null;
    });
    builder.addCase(taxSaveData.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.taxLoading = false;
          state.taxSuccess = accountType == 2 ? false : true;
          state.taxError = accountType == 2 ? true : false;
          state.taxMessage = action.payload.data.message;
          state.taxData = action.payload.data.data;
        } else {
          state.taxLoading = false;
          state.taxSuccess = false;
          state.taxError = true;
          state.taxMessage =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.taxLoading = false;
        state.taxSuccess = false;
        state.taxError = true;
        state.taxMessage =
          accountType == 2
            ? action.payload?.data?.message
            : action.payload?.response?.data?.message
              ? action.payload?.response?.data?.message
              : action.payload.message;
        state.taxData = null;
      }
    });
    builder.addCase(taxSaveData.rejected, (state) => {
      state.taxLoading = false;
      state.taxSuccess = false;
      state.taxError = true;
      state.taxMessage = null;
      state.taxData = null;
    });
    // ------------------------------------------------- 
    builder.addCase(getTaxClaimFormData.pending, (state) => {
      state.taxLoading = true;
      state.taxSuccess = false;
      state.taxError = false;
      state.taxMessage = null;
      state.taxData = null;
    });
    builder.addCase(getTaxClaimFormData.fulfilled, (state, action) => {
      if (action.payload.status == 200 || action.payload.status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.taxClaimLoading = false;
          state.taxClaimSuccess = accountType == 2 ? false : true;
          state.taxClaimError = accountType == 2 ? true : false;
          state.taxClaimMessage = action.payload.data.message;
          state.taxClaimData = action.payload.data.data;
        } else {
          state.taxClaimLoading = false;
          state.taxClaimSuccess = false;
          state.taxClaimError = true;
          state.taxClaimMessage =
            action.payload.data.msg == undefined
              ? action.payload.data.message
              : action.payload.data.msg;
        }
      } else {
        state.taxClaimLoading = false;
        state.taxClaimSuccess = false;
        state.taxClaimError = true;
        state.taxClaimMessage =
          accountType == 2
            ? action.payload?.data?.message
            : action.payload?.response?.data?.message
              ? action.payload?.response?.data?.message
              : action.payload.message;
        state.taxClaimData = null;
      }
    });
    builder.addCase(getTaxClaimFormData.rejected, (state) => {
      state.taxClaimLoading = false;
      state.taxClaimSuccess = false;
      state.taxClaimError = true;
      state.taxClaimMessage = null;
      state.taxClaimData = null;
    });
  },
});

export const { initTaxState, initTaxClaim } =
  TaxSlice.actions;

export default TaxSlice.reducer;
